import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    loginFromToken,
    logout,
} from '../../actions/authActions';
import {
    getMe,
} from '../../actions/userActions';

import ApiAuth from '../../services/ApiAuth';

export default function (RestrictedComponent) {
    class AuthProvider extends Component {
        checkAuth(data = this.props.data) {
            // login
            if (ApiAuth.isLogged() && data) {
                return Promise.resolve();
            }

            // login after refresh
            if (ApiAuth.isLogged() && !data) {
                return this.props.loginFromToken(ApiAuth.getAuth());
            }

            // user not logged
            if (!data) {
                return Promise.resolve(this.props.history.push('/login'));
            }
        }

        componentWillReceiveProps(nextProps) {
            if ((this.props.data && !nextProps.data) || nextProps.error || nextProps.errorFromToken) {
                // logout
                ApiAuth.logout();
            }

            this.checkAuth(nextProps.data);
        }

        componentDidMount() {
            const auth = this.checkAuth();

            if (auth instanceof Promise) {
                auth
                    .then(() => this.props.getMe())
                    .then(() => {
                        if (!this.props.isAdmin) {
                            this.props.history.push('/login');
                         }
                    });
            }
        }

        render() {
            return <div>
                {
                    this.props.data &&
                    this.props.user &&
                    this.props.isAdmin &&
                    !this.props.error &&
                    !this.props.errorFromToken &&
                    <RestrictedComponent { ...this.props } />
                }
            </div>;
        }
    }

    return connect(
        (state) => ({
            data: state.auth.accessData.access_token,
            error: state.auth.login.error,
            errorFromToken: state.auth.login.errorFromToken,
            user: state.user.info.data.id,
            isAdmin: state.user.info.data.admin,
        }),
        ({
             getMe, loginFromToken, logout
        }),
    )(AuthProvider);
}



// WEBPACK FOOTER //
// ./src/components/AuthProvider/AuthProvider.js